import { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { ClaimSelectionContext } from "./ClaimSelectionContext";

const EMPTY_SELECTION: ReadonlySet<string> = new Set<string>();

/**
 * Holds the claim selection for one mounting of the claims tab. Mounted around the tab
 * scaffold so the list and the action buttons in its tab-actions row see the same selection; the
 * selection ends with the tab.
 */
export function ClaimSelectionProvider({ children }: PropsWithChildren) {
  const [selectedClaimIds, setSelectedClaimIds] = useState<ReadonlySet<string>>(EMPTY_SELECTION);

  const clearSelection = useCallback(() => setSelectedClaimIds(EMPTY_SELECTION), []);

  const value = useMemo(
    () => ({ selectedClaimIds, setSelectedClaimIds, clearSelection }),
    [selectedClaimIds, clearSelection]
  );

  return <ClaimSelectionContext.Provider value={value}>{children}</ClaimSelectionContext.Provider>;
}
